import AppHeader from "../../layout/AppHeader";
import DeadlineStateMatrix from '../../xpost/views/financial/deadline/DeadlineStateMatrix.vue';

const PriceDeadlineRoutes = [
    {
        path: "/cadastro/prazos",
        name: "price.deadline.state",
        meta: {
            role: ['1'],
        },
        components: {
            header: AppHeader,
            default: DeadlineStateMatrix,
        }
    }
]

export default PriceDeadlineRoutes;
